export const AUDIT_SCHEMA_VERSION = 1;

export const createAuditEntry = ({
  action,
  detail,
  entityType = "organization",
  entityId,
  profile,
  workspaceId,
  sessionMode = "account",
  at = new Date().toISOString(),
  id = `activity-${Date.now()}-${Math.random().toString(16).slice(2, 7)}`,
}) => ({
  id,
  schemaVersion: AUDIT_SCHEMA_VERSION,
  at,
  workspaceId: workspaceId || "",
  actorId: profile?.id || "unknown-user",
  actor: profile?.name || "Unknown user",
  actorRole: profile?.role || "Unknown role",
  sessionMode,
  action,
  detail,
  entityType,
  entityId: entityId || workspaceId || "unknown-record",
});
